import { gsap, ScrollTrigger } from "@/composeables/gsap";

export const init = () => {

    const factSections = gsap.utils.toArray(".section-facts");

    factSections.forEach(function (factSection) {

        const items = factSection.querySelectorAll(".section-facts__item");
        if (!items.length) return;

        gsap.set(items, { autoAlpha: 0, y: 40 });

        ScrollTrigger.batch(items, {
            interval: 0.1,
            batchMax: 4,
            invalidateOnRefresh: true,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: 0.15, overwrite: true, ease: "expo", duration: 1 }),
        });

    });
}

export default init;
